export default "__VITE_ASSET__bQJ7ZVoc__"